import {SEARCH_TERM_CAROUSEL_RESULTS_MIN} from '../../../utils/carouselLogUtils';

const getShowDestinationCarousel = (
    isLoadingOrRedirecting,
    typeaheadSuggestion,
    pageCount,
    resultCount,
    discoveryXploreFeeds,
    showDestinationRecommendations
) => {
    return (
        !isLoadingOrRedirecting &&
        !!(
            typeaheadSuggestion &&
            pageCount &&
            pageCount > 0 &&
            resultCount &&
            resultCount >= SEARCH_TERM_CAROUSEL_RESULTS_MIN &&
            discoveryXploreFeeds &&
            discoveryXploreFeeds.results.length > 0 &&
            showDestinationRecommendations
        )
    );
};

const getShowFlexibleDatesContainer = (
    isDatelessSearch,
    isSubsequentFlexDatesView,
    resultCount,
    percentBooked,
    expandedCoverage = true
) => {
    const maxResultsCount = expandedCoverage ? 100 : 50;
    return (
        !isDatelessSearch &&
        !!(
            isSubsequentFlexDatesView ||
            (resultCount &&
                resultCount !== 0 &&
                resultCount <= maxResultsCount &&
                percentBooked &&
                percentBooked.currentPercentBooked &&
                percentBooked.currentPercentBooked >= 0.5)
        )
    );
};

const getShowMabCarousels = (
    isLoadingOrRedirecting,
    pinnedPropertyListing,
    showFlexibleDatesContainer,
    showDestinationCarousel
) => {
    return (
        !isLoadingOrRedirecting &&
        !pinnedPropertyListing &&
        !showFlexibleDatesContainer &&
        !showDestinationCarousel
    );
};

export {
    getShowDestinationCarousel,
    getShowFlexibleDatesContainer,
    getShowMabCarousels
};
